import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  departments: [],
};
const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    setDepartments(state, action) {
      state.departments = action.payload;
    },
    addDepartment(state, action) {
      state.departments.push(action.payload);
    },
    setDepartment(state, action) {
      state.profile = action.payload;
    },
    deleteDepartment(state, action) {
      state.departments = state.departments.filter(
        (d) => d._id !== action.payload
      );
    },
  },
});

const departmentReducer = departmentSlice.reducer;
const departmentActions = departmentSlice.actions;

export { departmentActions, departmentReducer };
